import { render, staticRenderFns } from "./Embbed.vue?vue&type=template&id=52fe2e5c&"
import script from "./Embbed.vue?vue&type=script&lang=js&"
export * from "./Embbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports